export const VERIFICATION_RESULTS = [
  "PENDING",
  "ITEM_LIKE_NEW",
  "ITEM_NOT_RECEIVED",
  "ITEM_DAMAGED",
] as const;

export const VERIFICATION_STATUSES = ["PASSED", "FAILED", "PENDING"] as const;

export const TRACKING_EVENT_STATUSES = [
  "RECEIVED_AT_RETURN_POINT",
  "IN_TRANSIT_TO_HUB",
  "RECEIVED_AT_HUB",
  "APPROVED",
  "PENDING",
] as const;

export enum ReturnBearCaseMethodType {
  RETURN_POINT = "RETURN_POINT",
  COURIER = "COURIER",
}
